<template>
  <div class="transparent-kendo-tab">
    <div class="page-header driver_header_mobile d-flex w-100">
      <div class="title-col d-flex w-50">
        <span class="title-icon">
          <b-icon-folder-fill></b-icon-folder-fill>
        </span>
        <span class="title-text">VEHICLE MANAGEMENT</span>
      </div>
      <div class="text-right d-flex ml-auto">
        
      <kendo-button
      name="ERRORS  "
      class="k-button filter-button mt-2 ml-2"
      v-if="EmployeeErrors.length"
      @click="showErrors"
      >Errors</kendo-button>
      <button class="btn btn-icon tooltip" @click="exportExcel">
      
      <span class="nt-file-text"></span>
      <span class="tooltiptext">Export</span>
    </button>

    <button class="btn btn-icon tooltip" @click="downloadTemplate">
      <span class="nt-download"></span>
      <span class="tooltiptext">Download templates</span>
    </button>
  
    <button
    class="btn btn-icon tooltip"
    ref="imageUploader"
    @click="$refs.vehicletemplateUpload.click()"
  >
    <span class="nt-upload"></span>
    <span class="tooltiptext">Upload</span>
  </button>

  <!-- <kendo-button
    ref="imageUploader"
    class="k-primary ml-1"
    icon="upload"
    @click="$refs.templateUpload.click()"
  >
    Upload</kendo-button
  > -->
  <input
    hidden
    ref="vehicletemplateUpload"
    @change="uploadTemp"
    type="file"
    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
  />
        <!-- <button class="btn btn-icon tooltip" @click="exportExcel">
          <span class="nt-file-text"></span>
          <span class="tooltiptext">Export</span>
        </button>

        <button class="btn btn-icon tooltip" ref="imageUploader" @click="$refs.templateUpload.click()">
          <span class="nt-upload"></span>
          <span class="tooltiptext">Upload</span>
        </button>

        <button class="btn btn-icon tooltip" @click="downloadTemplate">
          <span class="nt-download"></span>
          <span class="tooltiptext">Download templates</span>
        </button> -->
      </div>
    </div>
    <div class="page-body">
      <kendo-tabstrip class>
        <ul>
          <li class="k-state-active" @click="setSelectedTab('VEHICLE')">VEHICLE</li>
          <li v-if="validateUserForVehicleType" @click="setSelectedTab('VEHICLE_TYPE')">VEHICLE TYPE</li>
          <li v-if="validateUserForVehicleUserMap" @click="setSelectedTab('VEHICLE_USER_MAP')">VEHICLE USER MAP</li>
        </ul>
        <div class="overflow-hidden">
          <vehicle ref="vehicleForm"/>
        </div>
        <div class="">
          <vehicleType ref="vehicleTypeData"/>
        </div>
        <div>
          <vehicle-user-map ref="vehicleUserMap" />
        </div>
      </kendo-tabstrip>
    </div>
      <employee-errors
  ref="vehicleError"
  :errors="EmployeeErrors"
  :title="title"
></employee-errors>
  </div>
</template>
<script>
import vehicleType from "./VehicleType";
import vehicle from "../Vehicle/Vehicle";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import { createNamespacedHelpers } from "vuex";
const { mapState,mapGetters } = createNamespacedHelpers("vehicle");
import EmployeeErrors from "@/components/EmployeeError";
import { USER_ROLES } from "@/utils/constants";
import { isAllowedUser } from "@/utils/auth-helper";
import VehicleUserMap from '../VehicleUserMap/VehicleUserMap.vue';
import moment from "moment-timezone";

// import vendorForm from "./VendorForm"
export default {
  components: {
    vehicle,
    vehicleType,
    VehicleUserMap,
    EmployeeErrors
    // vendorForm
  },
  data: function () {
    return {
      add: this.$route.params.add,
      USER_ROLES,
      selectedTab:"VEHICLE"
    };
  },
  methods: {
    exportExcel() {
      console.log('getVehicleData',this.selectedTab)
      if(this.selectedTab ==='VEHICLE'){
        console.log("ed",this.getVehicles)
        const a= this.getVehicles.map(v=>{
          const fType = this.$store.getters["vehicle/getVehicleFuelTypes"].find(ft => ft.id === parseInt(v.fuelType))
          return {
          ...v,
          taxExpiryDate:v.taxExpiryDate?moment(v.taxExpiryDate).format("DD-MM-YYYY"):"",
          insuranceExpiry:v.insuranceExpiry?moment(v.insuranceExpiry).format("DD-MM-YYYY"):"",
          permitEnd:v.permitEnd?moment(v.permitEnd).format("DD-MM-YYYY"):"",
          fcExpiryDate:v.fcExpiryDate?moment(v.fcExpiryDate).format("DD-MM-YYYY"):"",
          emissionExpiry:v.emissionExpiry?moment(v.emissionExpiry).format("DD-MM-YYYY"):"",
          maintenanceDueDate:v.maintenanceDueDate?moment(v.maintenanceDueDate).format("DD-MM-YYYY"):"",
          driverID:v.driverID?v.driverName:'',
          vehicleType:v.vehicleType?v.type:'',
          fuelType:fType ? fType.name : ''

        }});
         saveExcel({
        data:a,
        fileName: "vehicle",
        columns: this.$refs.vehicleForm.returnColumns(),
      });
      }
      if(this.selectedTab ==='VEHICLE_USER_MAP'){
      saveExcel({
        data:this.getVehicleUserData,
        fileName: "vehicle",
        columns: this.$refs.vehicleUserMap.mapUserColumn(),
      });
      }
      if(this.selectedTab ==='VEHICLE_TYPE'){
      saveExcel({
        data:this.getVehicleTypeData,
        fileName: "vehicle",
        columns: this.$refs.vehicleTypeData.vehicleTypeColumn(),
      });
      }
    },
    downloadTemplate() {
       this.$store.dispatch("vehicle/DownloadTemp");
      // saveExcel({
      //   data: [],
      //   fileName: "sampleTemplate",
      //   columns: this.selectedVehicleColumns,
      // });
    },
      uploadTemp(e) {
      this.$store.dispatch("vehicle/uploadTemplate", e);
      this.$refs.vehicletemplateUpload.value = "";
    },
        showErrors: function() {
      this.$refs.vehicleError.show();
    },
    async uploadTemplate(e) {
      await this.$store.dispatch("vehicle/uploadTemplate", e);
      this.$refs.templateUpload.value = "";
    },
    setSelectedTab(e){
      console.log("#Vehicle",e)
      this.selectedTab=e;
    }
  },
  computed : {
    ...mapState(["vehicleData", 'selectedVehicleColumns','EmployeeErrors','title']),
    ...mapGetters(['getVehicleData',"getVehicles","getVehicleUserMap"]),
    validateUserForVehicleType : () => isAllowedUser([USER_ROLES.SUPER_ADMIN]),
    validateUserForVehicleUserMap : () => isAllowedUser([USER_ROLES.SUPER_ADMIN, USER_ROLES.TENANT_ADMIN]),
    getVehicleUserData(){
      return this.$store.getters['vehicleUserMap/getVehicleUserMap']
    },
    getVehicleTypeData(){
      return this.$store.getters["vehicleType/getVehicleTypes"] 
    }
    
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {

  
}
</style>
